import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Chart } from "chart.js/auto";
import { useReactToPrint } from 'react-to-print';
import './MainDashboard.css';
import VantisLogo from '../../images/clientlogos/Vantis Vascular.png';



export default function MainDashboard() {
  const {
    user,
    companyId,
    displayName,
    loading,
    error,
    sourceFile,
    mainDashboardObject,
    vantisObject,
    metricsServerData,
    salesAccess,
    niceMoney,
    formatNumber,
    niceASP,
    nicePercent,
  } = useOutletContext();

 

  function forceNumberValue(value) {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;

    const num = String(value).replace(/[^0-9.-]+/g, ''); // Remove non-numeric characters except for '.' and '-'
    const parsed = Number(num);
    return Number.isFinite(parsed) ? parsed : 0;
  }


  // If you're reusing /api/metrics/portal, you'd add these to metrics on the server.
  const data = useMemo(() => mainDashboardObject || {}, [mainDashboardObject]);
  const vantisData = useMemo(() => vantisObject || {}, [vantisObject]);
  console.log("data", data);
  console.log("vantisData", vantisData);

  const salesAccessObject = useMemo(() => salesAccess || {}, [salesAccess]);

  // Latest Date (found thru a search within data.calendarInfo) \\
  const latestDate = data?.calendarInfo?.find(ci => ci.valueName === "Data Thru")?.value;
  // console.log('Latest Date:', latestDate);

  const dashboardPrintRef = useRef(null);
  const handlePrintDashboard = useReactToPrint({
    contentRef: dashboardPrintRef,
    documentTitle: () => `Vantis Sales Reporting ${latestDate || ""}`,
    pageStyle: `
      @page {
        size: Letter landscape;
        margin: 0.25in;
      }

      @media print {
        html,
        body {
          margin: 0 !important;
          padding: 0 !important;
          background: #fff !important;
        }

        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
    `,
  });

  //Todays Date \\
  const todaysDate = new Date().toISOString().slice(0, 10);

  // Delta Date Previous Qtr \\
  const deltaDatePreviousQtr = data?.calendarInfoPreviousQtr?.find(ci => ci.valueName === "Previous Quarter Delta Date")?.value;
  // console.log('Delta Date Previous Qtr:', deltaDatePreviousQtr);

  // Current Qtr Date Range \\
  const CurrentQtrStart = data?.currentQtr_DateRanges?.start;
  const CurrentQtrEnd = data?.currentQtr_DateRanges?.end;
  // console.log('Current Qtr Start:', CurrentQtrStart);
  // console.log('Current Qtr End:', CurrentQtrEnd);

  // Previous Qtr Date Range \\
  const PreviousQtrStart = data?.previousQtr_DateRanges?.start;
  const PreviousQtrEnd = data?.previousQtr_DateRanges?.end;
  // console.log('Previous Qtr Start:', PreviousQtrStart);
  console.log('Previous Qtr End:', PreviousQtrEnd);


  // Sales Graph Data Points \\
  const aspGraphDataPoints = data?.aspGraphDataPoints || data?.metrics?.mainDashboard?.aspGraphDataPoints || [];

  // Helper to format numbers into commas for thousands (used in tables with large numbers)
   const commaColumns = new Set([ // add any metric labels (from "territoryKeyByLabel") here whose values should be formatted with commas
    "Total Sales Units",
    "Orders from Existing Accounts",
    "Orders from Base Accounts",
    "Total Orders",
  ]);

  const formatByLabel = (label, value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return value ?? "";
    return commaColumns.has(label) ? formatNumber(num) : value;
  };

  // Current Qtr Calendar Summary \\
  const caledarLabelRenames = {
    "Total WeekDays Elapsed": "Business Days Elapsed",
    "Total WeekDays in Quarter": "Total Business Days",
  };

  const calendarRows = [
    ...(data?.calendarInfo || data?.metrics?.mainDashboard?.calendarInfo || []).map(
      ({ valueName, value }) => [caledarLabelRenames[valueName] || valueName, value]
    ),
    ["Today's Date", todaysDate],
  ];
  console.log('Calendar Rows:', calendarRows);

  const totalWeekDaysInQtr = data?.calendarInfo?.find(
    (ci) => ci.valueName === "Total WeekDays in Quarter"
  );
  const elapsedWeekDaysInQtr = data?.calendarInfo?.find(
    (ci) => ci.valueName === "Total WeekDays Elapsed"
  );

  // 1099 Employment Type Stats CURRENT QTR \\
  const all1099Stats = data?.all1099CurrentQtrStats || [];
  const all1099Rows = all1099Stats.map(({ valueName, value }) => [valueName, value]);
  const all1099Names = all1099Stats.map(s => s.valueName);
  const all1099Values = all1099Stats.map(s => formatByLabel(s.valueName, s.value));
  // console.log(all1099Stats);
  // console.log(all1099Names);
  // console.log(all1099Values);

  // Direct/Hybrid Employment Type Stats CURRENT QTR \\
  const allNon1099Stats = data?.allNon1099CurrentQtrStats || [];
  const allNon1099Rows = allNon1099Stats.map(({ valueName, value }) => [valueName, value]);
  const allNon1099Names = allNon1099Stats.map(s => s.valueName);
  const allNon1099Values = allNon1099Stats.map(s => formatByLabel(s.valueName, s.value));
  // console.log(allNon1099Stats);
  // console.log(allNon1099Names);
  // console.log(allNon1099Values);

  // 1099 Employment Type Stats PREVIOUS QTR \\
  const all1099StatsPreviousQtr = data?.all1099PreviousQtrStats || [];
  const all1099RowsPreviousQtr = all1099StatsPreviousQtr.map(({ valueName, value }) => [valueName, value]);
  const all1099NamesPreviousQtr = all1099StatsPreviousQtr.map(s => s.valueName);
  const all1099ValuesPreviousQtr = all1099StatsPreviousQtr.map(s => formatByLabel(s.valueName, s.value));
  // console.log(all1099StatsPreviousQtr);
  // console.log(all1099NamesPreviousQtr);
  // console.log(all1099ValuesPreviousQtr);

  // Direct/Hybrid Employment Type Stats PREVIOUS QTR \\
  const allNon1099StatsPreviousQtr = data?.allNon1099PreviousQtrStats || [];
  const allNon1099RowsPreviousQtr = allNon1099StatsPreviousQtr.map(({ valueName, value }) => [valueName, value]);
  const allNon1099NamesPreviousQtr = allNon1099StatsPreviousQtr.map(s => s.valueName);
  const allNon1099ValuesPreviousQtr = allNon1099StatsPreviousQtr.map(s => formatByLabel(s.valueName, s.value));
  // console.log(allNon1099StatsPreviousQtr);
  // console.log(allNon1099NamesPreviousQtr);
  // console.log(allNon1099ValuesPreviousQtr);
  
  // Total Employment Type Stats CURRENT QTR \\
  const totalStats = data?.totalCurrentQtrStats || [];
  const totalRows = totalStats.map(({ valueName, value }) => [valueName, value]);
  const totalNames = totalStats.map(s => s.valueName);
  const totalValues = totalStats.map(s => formatByLabel(s.valueName, s.value));
  // console.log(totalStats);
  // console.log(totalNames);
  // console.log(totalValues);

  // Total Employment Type Stats PREVIOUS QTR \\
  const totalStatsPreviousQtr = data?.totalPreviousQtrStats || [];
  const totalRowsPreviousQtr = totalStatsPreviousQtr.map(({ valueName, value }) => [valueName, value]);
  const totalNamesPreviousQtr = totalStatsPreviousQtr.map(s => s.valueName);
  const totalValuesPreviousQtr = totalStatsPreviousQtr.map(s => formatByLabel(s.valueName, s.value));
  // console.log(totalStatsPreviousQtr);
  // console.log(totalNamesPreviousQtr);
  // console.log(totalValuesPreviousQtr);

  // Employment Type Rows and Labels CURRENT QTR \\
  const employmentTypeRows = [
    all1099Values,
    allNon1099Values,
    totalValues,
  ];
  // Employment Type Rows and Labels PREVIOUS QTR \\
  const employmentTypeRowsPreviousQtr = [
    all1099ValuesPreviousQtr,
    allNon1099ValuesPreviousQtr,
    totalValuesPreviousQtr,
  ];

  const employmentTypeLabels = ["1099", "Direct/Hybrid", "Total"];

  // By Territory/Sales Rep Stats (Rows & Labels) \\
  const territoryStats = data?.allTerritoriesCurrentQtr || [];
  const territoryKeyByLabel = {
    "Quota": "QuotaValue",
    "Total Sales": "TotalSales",
    "Delta To Quota": "DeltaToQuota",
    "% to Quota": "PercentToQuota",
    "Total Sales Units": "TotalUnits",
    "ASP": "ASP",
    "Run Rate": "RunRate",
    "Run Rate to Quota": "RunRateToQuota",
    "DPA (Devices Per Account)": "DPA",
    "Orders from New Accounts": "OrdersFromNewAccounts",
    "Orders from Existing Accounts": "OrdersFromExistingAccounts",
    "Orders from Base Accounts": "OrdersFromBaseAccounts",
    "Total Orders": "TotalOrders",
    "New Accounts": "NewAccounts",
    "Existing Accounts": "ExistingAccounts",
    "Base Accounts": "BaseAccounts",
    "Reordering Base Accounts": "ReorderingBaseAccounts",
    "Reorder Rate": "ReorderRate",
    "Total Accounts": "TotalAccounts",
    "New Accounts with Reorder(s)": "newAccountsWithReorders",
  };
  const quotaTerritoryStats = data?.quotaTerritoriesCurrentQtrDisplay;
  const nonQuotaTerritoryStats = data?.nonQuotaTerritoriesCurrentQtrDisplay;

  const quotaTerritoryRows = quotaTerritoryStats.map(t =>
    all1099Names.map(label => formatByLabel(label, t[territoryKeyByLabel[label]]))
  );
  const quotaTerritoryRowLabels = quotaTerritoryStats.map(
    t => `${t.SalesReps.join(" & ")}: ${t.Territory}`
  );

  const nonQuotaTerritoryRows = nonQuotaTerritoryStats.map(t =>
    all1099Names.map(label => formatByLabel(label, t[territoryKeyByLabel[label]]))
  );
  const nonQuotaTerritoryRowLabels = nonQuotaTerritoryStats.map(
    t => `${t.SalesReps.join(" & ")}: ${t.Territory}`
  );
  // console.log(territoryStats);
  // console.log(quotaTerritoryStats);
  // console.log(nonQuotaTerritoryStats);
  // console.log('Territory Rows:', quotaTerritoryRows);
  // console.log('Territory Row Labels:', quotaTerritoryRowLabels);
  // console.log('Non-Quota Territory Rows:', nonQuotaTerritoryRows);
  // console.log('Non-Quota Territory Row Labels:', nonQuotaTerritoryRowLabels);

  /* ---------- Aggregate SubTotal Rows into by Territory Datasets Current Qtr (Start) ---------- */
  const quotaTotals = data?.quotaTerritoriesCurrentQtrTotals;
  const nonQuotaTotals = data?.nonQuotaTerritoriesCurrentQtrTotals;

  const buildTerritoryRow = t =>
  all1099Names.map(label => formatByLabel(label, t[territoryKeyByLabel[label]]));

  const quotaTerritoryRowsWithTotal = quotaTotals
  ? [...quotaTerritoryRows, buildTerritoryRow(quotaTotals)]
  : quotaTerritoryRows;

  const nonQuotaTerritoryRowsWithTotal = nonQuotaTotals
  ? [...nonQuotaTerritoryRows, buildTerritoryRow(nonQuotaTotals)]
  : nonQuotaTerritoryRows;

  const quotaTerritoryRowLabelsWithTotal = quotaTotals
  ? [...quotaTerritoryRowLabels, "SubTotal"]
  : quotaTerritoryRowLabels;

const nonQuotaTerritoryRowLabelsWithTotal = nonQuotaTotals
  ? [...nonQuotaTerritoryRowLabels, "SubTotal"]
  : nonQuotaTerritoryRowLabels;
  /* ---------- Aggregate SubTotal Rows into by Territory Datasets Current Qtr (END) ---------- */

  /* ---------- Aggregate SubTotal Rows into by Territory Datasets Previous Qtr (Start) ---------- */
  const quotaTotalsPreviousQtr = data?.quotaTerritoriesPreviousQtrTotals;
  const nonQuotaTotalsPreviousQtr = data?.nonQuotaTerritoriesPreviousQtrTotals;

  // Reuse the same buildTerritoryRow function since the structure is the same

  const quotaTerritoryStatsPreviousQtr = data?.quotaTerritoriesPreviousQtrDisplay || [];
  const nonQuotaTerritoryStatsPreviousQtr = data?.nonQuotaTerritoriesPreviousQtrDisplay || [];

  const quotaTerritoryRowsPreviousQtr = quotaTerritoryStatsPreviousQtr.map(t =>
    all1099Names.map(label => formatByLabel(label, t[territoryKeyByLabel[label]]))
  );

  const nonQuotaTerritoryRowsPreviousQtr = nonQuotaTerritoryStatsPreviousQtr.map(t =>
    all1099Names.map(label => formatByLabel(label, t[territoryKeyByLabel[label]]))
  );

  const quotaTerritoryRowsWithTotalPreviousQtr = quotaTotalsPreviousQtr
  ? [...quotaTerritoryRowsPreviousQtr, buildTerritoryRow(quotaTotalsPreviousQtr)]
  : quotaTerritoryRowsPreviousQtr;

  const nonQuotaTerritoryRowsWithTotalPreviousQtr = nonQuotaTotalsPreviousQtr
  ? [...nonQuotaTerritoryRowsPreviousQtr, buildTerritoryRow(nonQuotaTotalsPreviousQtr)]
  : nonQuotaTerritoryRowsPreviousQtr;

  const quotaTerritoryRowLabelsWithTotalPreviousQtr = quotaTotalsPreviousQtr
  ? [...quotaTerritoryRowLabels, "SubTotal"]  
  : quotaTerritoryRowLabels;

const nonQuotaTerritoryRowLabelsWithTotalPreviousQtr = nonQuotaTotalsPreviousQtr
  ? [...nonQuotaTerritoryRowLabels, "SubTotal"]
  : nonQuotaTerritoryRowLabels;
  /* ---------- Aggregate SubTotal Rows into by Territory Datasets Previous Qtr (END) ---------- */

  /* ---------- Daily Sales Line Graph Current/Previous Qtr (START) ---------- */
  const dailySalesDataPoints =
  data?.dailySalesDataPoints || data?.metrics?.mainDashboard?.dailySalesDataPoints || [];

  const monthlySalesDataPoints =
    data?.monthlySalesDataPoints || data?.metrics?.mainDashboard?.monthlySalesDataPoints || [];
    // console.log('Daily Sales Data Points:', dailySalesDataPoints);
  /* ---------- END Daily Sales Line Graph Current/Previous Qtr (END) ---------- */

  /* ---------- Last 4 Qtr Trends Table (START) ---------- */
  const last4QtrTrendsRowLabels = ['Sales', 'Average Daily Sales', 'Sales Units', 'Average Daily Sales Units', 'Run Rate', 'DPA']

  const last4QtrTrendsTableColumnLabels = data?.last4QtrTrendsTableColumnHeaders.map(l => l.value || "") || [];
  const last4QtrTrendsRowHeaderLabel = last4QtrTrendsTableColumnLabels[0] || "";
  const last4QtrTrendsTableQuarterLabels = last4QtrTrendsTableColumnLabels.slice(1);
  // console.log(last4QtrTrendsTableColumnLabels);

  const last4QtrTrendsTableRows = [
  data?.last4QtrTrendsTableTest.map(r => r.amountTotal), // sales
  data?.last4QtrTrendsTableTest.map(r => r.amountDailyAvg), // average daily sales
  data?.last4QtrTrendsTableTest.map(r => formatNumber(r.qtrTotal)), // sales units
  data?.last4QtrTrendsTableTest.map(r => formatNumber(Math.round(r.qtyDailyAvg))), // average daily sales units
  data?.last4QtrTrendsTableTest.map(r => r.runRate), // run rate
  data?.last4QtrTrendsTableTest.map(r => r.dpa), // dpa
  ];
  /* ---------- END Last 4 Qtr Trends Table (END) ---------- */

  /* ---------- Current Qtr vs Same Qtr Last Year Trends Table (START) ---------- */

  const currentQtrVsLastYearTrendsTableColumnLabels =
    data?.currentQtrToSameQtrLastYearTrendsTableColumnHeaders.map(l => l.value || "") || [];
  const currentQtrVsLastYearRowHeaderLabel = currentQtrVsLastYearTrendsTableColumnLabels[0] || "";
  const currentQtrVsLastYearQuarterLabels = currentQtrVsLastYearTrendsTableColumnLabels.slice(1);
  // console.log(currentQtrVsLastYearTrendsTableColumnLabels);

  const currentQtrVsLastYearTrendsTableRows = [
    data?.currentQtrToSameQtrLastYearTrendsTableTest.map(r => r.amountTotal),
    data?.currentQtrToSameQtrLastYearTrendsTableTest.map(r => r.amountDailyAvg),
    data?.currentQtrToSameQtrLastYearTrendsTableTest.map(r => formatNumber(r.qtrTotal)),
    data?.currentQtrToSameQtrLastYearTrendsTableTest.map(r => formatNumber(Math.round(r.qtyDailyAvg))),
    data?.currentQtrToSameQtrLastYearTrendsTableTest.map(r => r.runRate),
    data?.currentQtrToSameQtrLastYearTrendsTableTest.map(r => r.dpa),
  ];
  /* ---------- END Current Qtr vs Same Qtr Last Year Trends Table (END) ---------- */


  /* ----------------------------  VANTIS SPECIFIC TABLES & GRAPHS (START) ---------------------------------------------- */

  /* ---------- Overall Summary Table: Current Qtr/Current YTD/ Company LTD (START) ---------- */

  const overallSummarySourceContents = vantisData?.vantisOverallSummaryTableRowContents || []; // expecting an array of objects with this shape: { valueName: string, valueCurrentQtr: number|string, valueCurrentYTD: number|string, valueLTD: number|string }

  const overallSummaryTableColumnLabels = vantisData?.vantisOverallSummaryTableColumnHeaders || []; // expecting an array of 3 column header strings: [Current Qtr, Current YTD, Company LTD]
  
  const overallSummaryTableRowLabels = overallSummarySourceContents.map( // expecting an array of 3 column header strings: [Sales to Date, Untits to Date, ASP, Customers to Date]
      (row) => row.valueName 
    );
  
  const formatOverallSummaryValue = (label, value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return value ?? "";

    if (label === "Sales to Date") {
      return niceMoney(num);
    }

    if (label === "ASP") {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    }

    return formatNumber(num);
  };

  const overallSummaryTableRows = overallSummarySourceContents.map(
    (row) => [
      formatOverallSummaryValue(row.valueName, row.valueCurrentQtr),
      formatOverallSummaryValue(row.valueName, row.valueCurrentYTD),
      formatOverallSummaryValue(row.valueName, row.valueLTD),
    ]
  );

  /* ---------- END Overall Summary Table: Current Qtr/Current YTD/ Company LTD (END) ---------- */

  /* ---------- Current Qtr Highlights and Lowlights Table (START) ---------- */
  const companyTrendsHighlights = data?.companyTrendsSummaryRankedHighlights || [];
  const companyTrendsLowlights = data?.companyTrendsSummaryRankedLowlights || [];

  const companyTrendsSummaryTableRows = Array.from(
    { length: Math.max(companyTrendsHighlights.length, companyTrendsLowlights.length) },
    (element, i) => {
      const h = companyTrendsHighlights[i];
      const l = companyTrendsLowlights[i];

      return [
        i + 1,
        h?.valueName ? <strong>{h.valueName}</strong> : "Not populating Metric Name Correctly",
        h?.valueCurrentQtrToPreviousQtr ?? "Not populating Metric Value Correctly",
        h?.valueCurrentQtrToSameQtrLastYr ?? "Not populating Metric Value Correctly",
        l?.valueName ? <strong>{l.valueName}</strong> : "Not populating Metric Name Correctly",
        l?.valueCurrentQtrToPreviousQtr ?? "Not populating Metric Value Correctly",
        l?.valueCurrentQtrToSameQtrLastYr ?? "Not populating Metric Value Correctly",
      ];
    }
  );
  // console.log(companyTrendsSummaryTableRows);

  /* ---------- END Current Qtr Highlights and Lowlights Table (END) ---------- */

  /* ---------- Current Qtr vs Same Qtr Last Year Trends Table (START) ---------- */
  
    const totalCurrentQtrStats = data?.totalCurrentQtrStats || [];
    console.log("Total Current Qtr Stats:", totalCurrentQtrStats);
    const totalPreviousQtrStats = data?.totalPreviousQtrStats || [];
    console.log("Total Previous Qtr Stats:", totalPreviousQtrStats);
    const totalPerformanceLabelRenames = {
      "Total Sales": "Sales",
      "Total Sales Units": "Units",
      "% to Quota": "% To Quota",
    };
    const normalizeTotalPerformanceLabel = (label) => totalPerformanceLabelRenames[label] || label;
    const formatMetricValue = (value) => (
      value === null || value === undefined || value === "" ? "" : formatNumber(value)
    );
    const formatDeltaMoney = (value) => (
      value < 0 ? `(${niceMoney(Math.abs(value))})` : niceMoney(value)
    );
    const formatDeltaNumber = (value) => (
      value < 0 ? `(${formatNumber(Math.abs(value))})` : formatMetricValue(value)
    );
    const parseTableNumber = (value) => {
      if (value === null || value === undefined || value === "") return null;
      if (typeof value === "number") return Number.isFinite(value) ? value : null;

      const parsed = Number(String(value).replace(/[^0-9.-]+/g, ""));
      return Number.isFinite(parsed) ? parsed : null;
    };
    const formatNumberCell = (value) => {
      const num = parseTableNumber(value);
      return num === null ? value ?? "" : formatNumber(num);
    };
    const formatMoneyCell = (value) => {
      const num = parseTableNumber(value);
      return num === null ? value ?? "" : niceMoney(num);
    };
    const formatAspCell = (value) => {
      const num = parseTableNumber(value);
      return num === null ? value ?? "" : niceASP(num);
    };
    const formatPercentCell = (value) => {
      const num = parseTableNumber(value);
      return num === null ? value ?? "" : nicePercent(num);
    };
    const formatDeltaMoneyCell = (value) => {
      const num = parseTableNumber(value);
      if (num === null) return value ?? "";
      return num < 0 ? `(${niceMoney(Math.abs(num))})` : niceMoney(num);
    };
    const formatDeltaNumberCell = (value) => {
      const num = parseTableNumber(value);
      if (num === null) return value ?? "";
      return num < 0 ? `(${formatNumber(Math.abs(num))})` : formatNumber(num);
    };

    const totalCurrentQtrStatsLabels = totalCurrentQtrStats
      .map(r => normalizeTotalPerformanceLabel(r.valueName))
      .slice(0, 8); // only show the sales/unit performance metrics
    const totalCurrentQtrStatsValues = [
      totalCurrentQtrStats.map(r => formatMetricValue(r.value)).slice(0, 8)
    ]; // expects an array of arrays
    
    // Calculate Header Labels for Previous Qtr
    const calendarInfoPreviousQtr = data?.calendarInfoPreviousQtr || [];
    const previousQtrDisplayEnd = // use the earlier of PreviousQtrEnd and deltaDatePreviousQtr for previous qtr date range display.
      PreviousQtrEnd && deltaDatePreviousQtr // if both are defined
        ? (PreviousQtrEnd < deltaDatePreviousQtr ? PreviousQtrEnd : deltaDatePreviousQtr) // if PreviousQtrEnd is earlier than deltaDatePreviousQtr, default to PreviousQtrEnd
        : deltaDatePreviousQtr || "N/A"; // if only one is defined, default to deltaDatePreviousQtr, otherwise "N/A"
    const previousQtrLabel1 = (`${calendarRows[1][1]} ${calendarRows[1][0]} in ${calendarInfoPreviousQtr[0].value} (${PreviousQtrStart} thru ${previousQtrDisplayEnd})`); // X Business Days Elapsed in Previous Qtr (Previous Qtr Date Range)
    const previousQtrLabel2 = (`Delta to ${calendarRows[1][1]} ${calendarRows[1][0]} in ${calendarInfoPreviousQtr[0].value}`); // Delta to Same days elapsed in Previous Qtr
    const previousQtrLabel3 = calendarInfoPreviousQtr[0].value; //Previous Qtr
    const previousQtrLabel4 = (`Delta to ${calendarInfoPreviousQtr[0].value}`); // Delta to Current Qtr
    const totalPreviousQtrStatsHeaderLabels = [previousQtrLabel1, previousQtrLabel2, previousQtrLabel3, previousQtrLabel4];

    // Previous Qtr Stats Labels
    const totalPreviousQtrStatsLabels = ['Sales', 'Units', 'Sales', 'Units','Sales', 'Units','Sales', 'Units',];
  
    const totalAmountPreviousQtr = vantisData?.totalAmountPreviousQtr || 0;
    const totalUnitsPreviousQtr = vantisData?.totalQtyPreviousQtr || 0;
    // Calculate Total Previous Qtr Stats Values
    const totalPreviousQtrStatsValues = [[
      /* 0 */ formatMetricValue(totalPreviousQtrStats[1]?.value), // Sales Previous Qtr
      /* 1 */ formatMetricValue(totalPreviousQtrStats[4]?.value), // Units Previous Qtr
      /* 2 */ formatDeltaMoney(forceNumberValue(totalCurrentQtrStats[1]?.value) - forceNumberValue(totalPreviousQtrStats[1]?.value)), // Delta Sales Current Qtr vs Previous Qtr
      /* 3 */ formatDeltaNumber(forceNumberValue(totalCurrentQtrStats[4]?.value) - forceNumberValue(totalPreviousQtrStats[4]?.value)), // Delta Units Current Qtr vs Previous Qtr
      /* 4 */ niceMoney(totalAmountPreviousQtr), // Total Sales Previous Qtr (from separate metric for easier access to raw number value)
      /* 5 */ formatMetricValue(totalUnitsPreviousQtr), // Total Units Previous Qtr (from separate metric for easier access to raw number value)
      /* 6 */ formatDeltaMoney(forceNumberValue(totalCurrentQtrStats[1]?.value) - totalAmountPreviousQtr), 
      /* 7 */ formatDeltaNumber(forceNumberValue(totalCurrentQtrStats[4]?.value) - totalUnitsPreviousQtr)
    ]]; // expects an array of arrays
    console.log('Total Previous Qtr Stats Values:', totalPreviousQtrStatsValues);


    // Put together Total Vantis Table \\
    const vantisTotalTableColumnLabels = [...totalCurrentQtrStatsLabels, ...totalPreviousQtrStatsLabels];
    console.log('Vantis Total Table Column Labels:', vantisTotalTableColumnLabels);
    const vantisTotalTableValues = [[
      ...totalCurrentQtrStatsValues[0],
      ...totalPreviousQtrStatsValues[0],
    ]]; // expects a single row of values
    console.log('Vantis Total Table Rows:', vantisTotalTableValues);
    const vantisTotalTableGroups = [
      {
        label: `${calendarRows[1]?.[1] || "N/A"} ${calendarRows[1]?.[0] || "Business Days Elapsed"} in Current Quarter (${CurrentQtrStart || "N/A"}-${todaysDate || "N/A"})`,
        span: totalCurrentQtrStatsLabels.length,
      },
      ...totalPreviousQtrStatsHeaderLabels.map(label => ({ label, span: 2 })),
    ];
    const vantisTotalPerformanceTable = {
      title: "US Sales Performance - Sales & Units",
      groups: vantisTotalTableGroups,
      columns: vantisTotalTableColumnLabels,
      rows: vantisTotalTableValues.map((values, index) => ({
        label: ["Total:"][index] || "",
        values,
      })),
    };

    const salesAndUnitsTableByAvp = vantisData?.salesAndUnitsTableByAvp || [];
    const accountAndOrdersTableByAvp = vantisData?.accountAndOrdersTableByAvp || [];
    const salesAndUnitsTableByTerritory = vantisData?.salesAndUnitsTableByTerritory || [];
    const accountAndOrdersTableByTerritory = vantisData?.accountAndOrdersTableByTerritory || [];
    const customerDaysSinceLastOrderRows = [
      vantisData?.customerDaysSinceLastOrderTableSortedByDaysSinceLastOrder
    ].find(Array.isArray) || [];
    const penetrationByHospitalRows = [
      vantisData?.unitsByMonthByCustomerLast15MonthsWithVantisColumns
    ].find(Array.isArray) || [];
    // console.log('Penetration by Hospital Rows:', penetrationByHospitalRows);

    const isTotalPerformanceRow = (row) =>
      row?.AVP === "Total" || row?.Area === "Total" || row?.["Sales Rep"] === "Total";
    const findTotalPerformanceRow = (rows = []) =>
      rows.find(isTotalPerformanceRow);

    const areaPerformanceLabels = (row) => {
      if (isTotalPerformanceRow(row)) return ["Total:", ""];
      return [row?.AVP ?? "", row?.AVP_Area ?? row?.Area ?? ""];
    };
    const territoryPerformanceLabels = (row) => {
      if (isTotalPerformanceRow(row)) return ["Total:", ""];
      return [row?.Area ?? row?.AVP_Area ?? "", row?.["Sales Rep"] ?? ""];
    };
    const totalPerformanceLabels = () => ["Total:"];

    const buildGroupedPerformanceTable = ({
      title,
      columns,
      rows,
      labelHeaders = [""],
      getLabels,
      getValues,
    }) => ({
      title,
      groups: vantisTotalTableGroups,
      columns,
      labelHeaders,
      rows: rows.map((row) => ({
        labels: getLabels(row),
        values: getValues(row),
      })),
    });

    const hasQuota = (row) => {
      const quota = parseTableNumber(row?.CurrentQtr?.Quota);
      return quota !== null && quota > 0;
    };

    const getSalesAndUnitsValues = (row) => [
      hasQuota(row) ? formatMoneyCell(row?.CurrentQtr?.Quota) : "",
      formatMoneyCell(row?.CurrentQtr?.Sales),
      hasQuota(row) ? formatDeltaMoneyCell(row?.CurrentQtr?.DeltaToQuota) : "",
      hasQuota(row) ? formatPercentCell(row?.CurrentQtr?.PercentToQuota) : "",
      formatNumberCell(row?.CurrentQtr?.Units),
      formatAspCell(row?.CurrentQtr?.ASP),
      formatMoneyCell(row?.CurrentQtr?.RunRate),
      hasQuota(row) ? formatPercentCell(row?.CurrentQtr?.RunRateToQuota) : "",
      formatMoneyCell(row?.PreviousQtr?.SalesBusinessDaysElapsed),
      formatNumberCell(row?.PreviousQtr?.UnitsBusinessDaysElapsed),
      formatDeltaMoneyCell(row?.PreviousQtr?.DeltaDifferenceSalesCurrentQtrToDeltaDatePreviousQtr),
      formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceUnitsCurrentQtrToDeltaDatePreviousQtr),
      formatMoneyCell(row?.PreviousQtr?.TotalSales),
      formatNumberCell(row?.PreviousQtr?.TotalUnits),
      formatDeltaMoneyCell(row?.PreviousQtr?.DeltaDifferenceSalesCurrentQtrToPreviousQtr),
      formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceUnitsCurrentQtrToPreviousQtr),
    ];

    const accountsAndOrdersTableColumnLabels = [
      "New Accounts",
      "Reordering Existing Accounts",
      "Non-Reordering Existing Accounts",
      "Total Accounts",
      // "New Accounts with Reorder(s)",
      "Reorder Rate",
      "Orders from New Accounts",
      "Orders from Existing Accounts",
      "Total Orders",
      "Reordering Existing Accounts",
      "Orders from Existing Accounts",
      "Reordering Existing Accounts",
      "Orders from Existing Accounts",
      "Reordering Existing Accounts",
      "Orders from Existing Accounts",
      "Reordering Existing Accounts",
      "Orders from Existing Accounts",
    ];

    const getAccountsAndOrdersValues = (row) => [
      formatNumberCell(row?.CurrentQtr?.NewAccounts),
      formatNumberCell(row?.CurrentQtr?.ReorderingExistingAccounts),
      formatNumberCell(row?.CurrentQtr?.NonReorderingExistingAccounts),
      formatNumberCell(row?.CurrentQtr?.TotalAccounts),
      // formatNumberCell(row?.CurrentQtr?.NewAccountsWithReorders),
      formatPercentCell(row?.CurrentQtr?.ReorderRate),
      formatNumberCell(row?.CurrentQtr?.OrdersFromNewAccounts),
      formatNumberCell(row?.CurrentQtr?.OrdersFromExistingAccounts),
      formatNumberCell(row?.CurrentQtr?.TotalOrders),
      // formatNumberCell(row?.PreviousQtr?.TotalAccountsBusinessDaysElapsed),
      // formatNumberCell(row?.PreviousQtr?.TotalOrdersBusinessDaysElapsed),
      // formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceTotalAccountsCurrentQtrToDeltaDatePreviousQtr),
      // formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceTotalOrdersCurrentQtrToDeltaDatePreviousQtr),
      // formatNumberCell(row?.PreviousQtr?.TotalAccountsPreviousQtr),
      // formatNumberCell(row?.PreviousQtr?.TotalOrdersPreviousQtr),
      // formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceTotalAccountsCurrentQtrToPreviousQtr),
      // formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceTotalOrdersCurrentQtrToPreviousQtr),
      formatNumberCell(row?.PreviousQtr?.ReorderingExistingAccountsPreviousQtrToDeltaDatePreviousQtr),
      formatNumberCell(row?.PreviousQtr?.OrdersFromExistingAccountsPreviousQtrToDeltaDatePreviousQtr),
      formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceReorderingExistingAccountsCurrentQtrToDeltaDatePreviousQtr),
      formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceOrdersFromExistingAccountsCurrentQtrToDeltaDatePreviousQtr),
      formatNumberCell(row?.PreviousQtr?.ReorderingExistingAccountsPreviousQtr),
      formatNumberCell(row?.PreviousQtr?.OrdersFromExistingAccountsPreviousQtr),
      formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceReorderingExistingAccountsCurrentQtrToPreviousQtr),
      formatDeltaNumberCell(row?.PreviousQtr?.DeltaDifferenceOrdersFromExistingAccountsCurrentQtrToPreviousQtr),
    ];

    const usAccountsAndOrdersRows = [
      findTotalPerformanceRow(accountAndOrdersTableByAvp) ||
      findTotalPerformanceRow(accountAndOrdersTableByTerritory),
    ].filter(Boolean);

    const salesAndUnitsPerformanceTables = [
      // salesAccessObject?.level === "company" ? vantisTotalPerformanceTable : null, // US Sales Performance

      salesAccessObject?.level === "company" ?
        buildGroupedPerformanceTable({ // Area Sales Performance
          title: "Area Sales Performance - Sales & Units",
          columns: vantisTotalTableColumnLabels,
          rows: salesAndUnitsTableByAvp,
          labelHeaders: ["AVP", "Area"],
          getLabels: areaPerformanceLabels,
          getValues: getSalesAndUnitsValues,
        }) :
      null,

      buildGroupedPerformanceTable({ // Territory Sales Performance
        title: "Territory Sales Performance - Sales & Units",
        columns: vantisTotalTableColumnLabels,
        rows: salesAndUnitsTableByTerritory,
        labelHeaders: ["Area", "Sales Rep"],
        getLabels: territoryPerformanceLabels,
        getValues: getSalesAndUnitsValues,
      }),
    ].filter(Boolean);
    const accountsAndOrdersPerformanceTables = [
      // salesAccessObject?.level === "company" ?  // US Accounts & Orders Performance
      //   buildGroupedPerformanceTable({
      //     title: "US Sales Performance - Accounts & Orders",
      //     columns: accountsAndOrdersTableColumnLabels,
      //     rows: usAccountsAndOrdersRows,
      //     getLabels: totalPerformanceLabels,
      //     getValues: getAccountsAndOrdersValues,
      //   }) :
      // null,

      salesAccessObject?.level === "company" ?
        buildGroupedPerformanceTable({ // Area Accounts & Orders Performance
          title: "Area Sales Performance - Accounts & Orders",
          columns: accountsAndOrdersTableColumnLabels,
          rows: accountAndOrdersTableByAvp,
          labelHeaders: ["AVP", "Area"],
          getLabels: areaPerformanceLabels,
          getValues: getAccountsAndOrdersValues,
        })
      : null,

      buildGroupedPerformanceTable({ // Territory Accounts & Orders Performance
        title: "Territory Sales Performance - Accounts & Orders",
        columns: accountsAndOrdersTableColumnLabels,
        rows: accountAndOrdersTableByTerritory,
        labelHeaders: ["Area", "Sales Rep"],
        getLabels: territoryPerformanceLabels,
        getValues: getAccountsAndOrdersValues,
      }),
    ].filter(Boolean);
    // const salesAndUnitsPerformanceTables = vantisPerformanceTables.slice(0, 3);
    // const accountsAndOrdersPerformanceTables = vantisPerformanceTables.slice(3);

  /* ---------- END Current Qtr vs Same Qtr Last Year Trends Table (END) ---------- */


  /* ----------------------------  VANTIS SPECIFIC TABLES & GRAPHS (END) ---------------------------------------------- */

  return (
    <main ref={dashboardPrintRef} className="dash dash--vantis">
      {/* Page header */}
      <header className="dash__header">
        <div className="dash__logoCrop dash__logoCrop--vantis">
          <img src={VantisLogo} alt="Logo" className="dash__logo" />
        </div>
        <div>
          <h1 className="dash__title">{displayName || companyId} Main Dashboard</h1>
          <p className="dash__subtitle">
            Welcome, {user?.name || null} <br /> Source file: {sourceFile || "Ammen Consulting SharePoint"}
          </p>
        </div>

        <div className="dash__headerActions">
          <button className="btn no-print"><Link className="dash__link" to="/portal">← Back to Portal</Link></button>
          <button type="button" className="btn no-print" onClick={handlePrintDashboard}>Print / Save PDF</button>
        </div>
      </header>

      {loading && <p>Loading…</p>}
      {error && <p className="dash__error">{error}</p>}

      {!loading && !error && (
        <>
          {/* =========================
              TOP STRIP (4 cards)
              ========================= */}
          <section className="dash__topGrid">
            <div className="dash__scrollInner dash__scrollInner--topGrid">
              <Card title="Current Qtr Calendar Summary">
                <KeyValueTable rows={calendarRows} />
              </Card>

              {/* <Card title="Legend">
                <ul className="dash__legend">
                  <li><span className="swatch swatch--blue" />Total Orders across all Accounts</li>
                  <li><span className="swatch swatch--green" />Unique Accounts</li>
                  <li><span className="no--swatch" />*Invoice and calendar dates may differ due to future entries</li>
                  <li><span className="no--swatch" /><span style={{ fontWeight: 'bold' }} >*Base Accounts </span>= Accounts with order(s) from previous 3 Qtrs</li>
                  <li><span className="no--swatch" /><span style={{ fontWeight: 'bold' }} >*DPA </span>= Total Units/Total Active Accounts</li>
                </ul>
              </Card> */}

              {/* <Card title="Last 4 Qtr Trends " className="dash__topTrendCard">
                <SimpleTable
                  columns={last4QtrTrendsTableQuarterLabels || []}
                  rows={last4QtrTrendsTableRows || []}
                  rowLabels={last4QtrTrendsRowLabels || []}
                  rowHeaderLabel={last4QtrTrendsRowHeaderLabel}
                />
              </Card> */}

              <Card title="Overall Summary Table" className="dash__topTrendCard">
                <SimpleTable
                  columns={overallSummaryTableColumnLabels || []}
                  rows={overallSummaryTableRows || []}
                  rowLabels={overallSummaryTableRowLabels || []}
                  rowHeaderLabel={''}
                />
              </Card>
            </div>
          </section>

          {/* =========================
              MID SUMMARY + CHARTS
              ========================= */}
          <section className="dash__band">
            <div className="dash__scrollInner dash__scrollInner--band">
              {/* <Card title="Company Trends Summary (Highlights / Lowlights)" className="dash__bandCard dash__bandCard--summary">
                <SimpleTable
                  columns={[
                    "#",
                    "Highlights",
                    "Current vs Prev Qtr",
                    "Current vs Same Qtr LY",
                    "Lowlights",
                    "Current vs Prev Qtr",
                    "Current vs Same Qtr LY",
                  ]}
                  rows={companyTrendsSummaryTableRows || [] }
                />
              </Card> */}

              <Card title="Trailing 5Q ASP" className="dash__bandCard dash__bandCard--asp">
                <AspLineChart
                  dataPoints={aspGraphDataPoints}
                  height={525}
                  formatMoney={niceASP}
                />
              </Card>

              <Card title="Cumulative Sales: Current vs Prior Quarter" className="dash__bandCard dash__bandCard--cumulative">
                {/* placeholder ??? swap in your chart component later */}
                <DailySalesLineChart
                  dataPoints={dailySalesDataPoints}
                  height={525}
                  formatMoney={niceMoney}
                />
              </Card>

              <Card title="Trailing 5 Qtr Monthly Sales & Units" className="dash__bandCard dash__bandCard--monthly">
                <div className="dash__chartFill">
                  <MonthlySalesUnitsChart
                    dataPoints={monthlySalesDataPoints}
                    height={525}
                    formatMoney={niceMoney}
                  />
                </div>
              </Card>
            </div>
          </section>

          {/* =========================
              BIG TABLE: OFFICIAL TERRITORIES
              ========================= */}

          {/* <section className="dash__section">
            <SectionHeader
              title="Current Qtr vs Same Qtr Last Yr (Official Territories Only)"
              rightNote={data?.calendar?.pctElapsed ? `${data.calendar.pctElapsed} of quarter elapsed` : null}
            />

            <div className="dash__tableWrap">
              <SimpleTable
                stickyHeader
                compact
                columns={data?.officialTerritories?.columns || []}
                rows={data?.officialTerritories?.rows || []}
                // Later: you can pass a cellClassName callback for conditional formatting
                // cellClassName={(r, c, v) => computeCellClass(r, c, v)}
              />
            </div>
          </section> */}

          {/* ========================= 
              Vasorum Table Legend
              ========================= */}

          {/* <Card title="Legend">
            <ul className="dash__legend 2">
              <li><span className="swatch swatch--blue" />Total Orders across all Accounts</li>
              <li><span className="swatch swatch--green" />Unique Accounts</li>
              <li><span className="no--swatch" />*Invoice and calendar dates may differ due to future entries</li>
              <li><span className="no--swatch" /><span style={{ fontWeight: 'bold' }} >Base Accounts </span>= Accounts with order(s) from previous 3 Qtrs</li>
              <li><span className="no--swatch" /><span style={{ fontWeight: 'bold' }} >DPA </span>= Total Units/Total Active Accounts</li>
            </ul>
          </Card> */}

          {/* =========================
              PERFORMANCE SECTIONS (STACK)
              ========================= */}

          <div className="dash__printPage dash__printPage--performanceSales">
            <div className="dash__scrollInner dash__scrollInner--performance">
              {salesAndUnitsPerformanceTables.map((groupedTable) => (
                <section
                  className="dash__section dash__section--performance"
                  key={groupedTable.title}
                >
                  <TwoUpTables groupedTable={groupedTable} />
                </section>
              ))}
            </div>
          </div>

          <div className="dash__printPage dash__printPage--performanceAccounts">
            <div className="dash__scrollInner dash__scrollInner--performance">
              {accountsAndOrdersPerformanceTables.map((groupedTable) => (
                <section
                  className="dash__section dash__section--performance"
                  key={groupedTable.title}
                >
                  <TwoUpTables groupedTable={groupedTable} />
                </section>
              ))}
            </div>
          </div>
          {salesAccessObject?.level === "company" ? 
            <section className="dash__section dash__section--customerDays">
              <div className="dash__scrollInner dash__scrollInner--customerDays">
                <CustomerDaysSinceLastOrderTable rows={customerDaysSinceLastOrderRows} />
              </div>
            </section> :
            null}

          <section className="dash__section dash__section--penetrationByHospital">
            <div className="dash__scrollInner dash__scrollInner--penetrationByHospital">
              <PenetrationByHospitalByMonthTable
                latestDate={latestDate}
                rows={penetrationByHospitalRows}
                data={vantisData}
                salesAccess={salesAccessObject}
              />
            </div>
          </section>

          {/* <section className="dash__section">
            {/* <SectionHeader title="Territory Sales Performance (House Accounts)" /> */}
            {/* <TwoUpTables
              tableHeader="Territory Sales Performance (House Accounts)"
              leftTitle={`Current Quarter (${data?.calendar?.currentWindow || "—"})`}
              rightTitle={`Previous Quarter (${data?.calendar?.previousWindow || "—"})`}
              leftColumns={data?.houseAccounts?.columns || []}
              leftRows={data?.houseAccounts?.currentRows || []}
              rightColumns={data?.houseAccounts?.columns || []}
              rightRows={data?.houseAccounts?.previousRows || []}
            />
          </section> */}

          {/* <section className="dash__section">
            <SectionHeader title="Manual Hospital Reassignment" />
            <div className="dash__tableWrap">
              <SimpleTable
                stickyHeader
                compact
                columns={data?.manualReassign?.columns || []}
                rows={data?.manualReassign?.rows || []}
              />
            </div>
          </section> */}
        </>
      )}
    </main>
  );
}

/* =========================
   Small presentational bits
   Keep these in-file for now.
   ========================= */

function Card({ title, children, className = "" }) {
  return (
    <div className={`card${className ? ` ${className}` : ""}`}>
      <div className="card__title">{title}</div>
      <div className="card__body">{children}</div>
    </div>
  );
}

function SectionHeader({ title, rightNote }) {
  return (
    <div className="sectionHeader">
      <h2 className="sectionHeader__title">{title}</h2>
      {rightNote ? <div className="sectionHeader__note">{rightNote}</div> : null}
    </div>
  );
}

function KeyValueTable({ rows = [] }) {
  return (
    <table className="kv">
      <tbody >
        {rows.map(([k, v]) => (
          <tr key={k} className="kv-all">
            <td className="kv__k">{k}</td>
            <td className="kv__v">{v ?? "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function TwoUpTables({
  groupedTable,
  tableHeader,
  leftTitle,
  leftColumns,
  leftRows,
  rightTitle,
  rightColumns,
  rightRows,
  allRowLabels,
  stacked = false,
}) {
  if (groupedTable) {
    return <GroupedPerformanceTable {...groupedTable} />;
  }

  if (stacked) {
    return (
      <div className="twoUp twoUp--stacked">
        <SectionHeader title={tableHeader} />
        <div className="twoUp__title">{leftTitle}</div>
        <div className="dash__tableWrap">
          <SimpleTable columns={leftColumns} rows={leftRows} rowLabels={allRowLabels} />
        </div>

        <SectionHeader title={tableHeader} />
        <div className="twoUp__title">{rightTitle}</div>
        <div className="dash__tableWrap">
          <SimpleTable columns={rightColumns} rows={rightRows} rowLabels={allRowLabels} />
        </div>
      </div>
    );
  }

  return (
    <div className="twoUp">
      <SectionHeader title={tableHeader} />
      <SectionHeader title={tableHeader} />
      <div className="twoUp__header">
        <div className="twoUp__title">{leftTitle}</div>
        <div className="twoUp__title">{rightTitle}</div>
      </div>
      <div className="twoUp__col">
        <div className="dash__tableWrap">
          <SimpleTable columns = {leftColumns} rows={leftRows} rowLabels={allRowLabels} />
        </div>
      </div>

      <div className="twoUp__col">
        <div className="dash__tableWrap">
          <SimpleTable columns = {rightColumns} rows={rightRows} rowLabels={allRowLabels} />
        </div>
      </div>
    </div>
  );
}

function GroupedPerformanceTable({ title, groups = [], columns = [], labelHeaders = [""], rows = [] }) {
  const rowHeaderLabels = labelHeaders.length > 0 ? labelHeaders : [""];
  const totalColumns = columns.length + rowHeaderLabels.length;
  const labelColWidths = rowHeaderLabels.length === 2 ? ["125px", "140px"] : ["265px"];
  const metricColWidths = [
    "155px",
    "135px",
    "135px",
    "135px",
    "105px",
    "115px",
    "135px",
    "145px",
    "90px",
    "90px",
    "90px",
    "90px",
    "90px",
    "90px",
    "90px",
    "90px",
  ];
  const colWidths = [
    ...labelColWidths,
    ...metricColWidths,
  ];
  const groupStartIndexes = new Set();
  const groupEndIndexes = new Set();
  let groupStartIndex = 0;

  groups.forEach((group) => {
    groupStartIndexes.add(groupStartIndex);
    groupStartIndex += group.span;
    groupEndIndexes.add(groupStartIndex - 1);
  });

  const getMetricBoundaryClasses = (cellIndex) => {
    const classes = [];

    if (groupStartIndexes.has(cellIndex)) classes.push("vantisPerf__metricCell--groupStart");
    if (groupEndIndexes.has(cellIndex)) classes.push("vantisPerf__metricCell--groupEnd");

    return classes;
  };

  const getMetricHeadClassName = (cellIndex) => {
    const classes = [
      "vantisPerf__metricHead",
      ...getMetricBoundaryClasses(cellIndex),
    ];

    return classes.join(" ");
  };

  const getMetricCellClassName = (cell, cellIndex) => {
    const classes = [
      "vantisPerf__metricCell",
      ...getMetricBoundaryClasses(cellIndex),
    ];

    if (isNegativeValue(cell)) classes.push("vantisPerf__negative");

    return classes.join(" ");
  };

  const getRowLabels = (row) =>
    row?.labels || [row?.label ?? ""];
  const isTotalRow = (rowLabels) =>
    rowLabels.some((label) => String(label).trim() === "Total:");

  return (
    <div className="vantisPerf">
      <div className="vantisPerf__title">{title}</div>
      <div className="dash__tableWrap vantisPerf__wrap">
        <table className="tbl vantisPerf__table">
          <colgroup>
            {colWidths.slice(0, totalColumns).map((width, index) => (
              <col key={`${width}-${index}`} style={{ width }} />
            ))}
          </colgroup>
          <thead>
            <tr>
              <th
                className="vantisPerf__rowHead"
                colSpan={rowHeaderLabels.length}
              ></th>
              {groups.map((group, index) => (
                <th
                  key={`${group.label}-${index}`}
                  className="vantisPerf__group"
                  colSpan={group.span}
                >
                  {group.label}
                </th>
              ))}
            </tr>
            <tr>
              {rowHeaderLabels.map((label, index) => (
                <th
                  className="vantisPerf__labelHead"
                  key={`${label}-${index}`}
                >
                  {label}
                </th>
              ))}
              {columns.map((column, index) => (
                <th
                  className={getMetricHeadClassName(index)}
                  key={`${column}-${index}`}
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td className="tbl__empty" colSpan={totalColumns}>No rows</td>
              </tr>
            ) : (
              rows.map((row, rowIndex) => {
                const rowLabels = getRowLabels(row);
                const rowKey = rowLabels.join("|") || rowIndex;

                return (
                  <tr
                    className={isTotalRow(rowLabels) ? "vantisPerf__totalRow" : undefined}
                    key={`${rowKey}-${rowIndex}`}
                  >
                    {rowHeaderLabels.map((header, labelIndex) => (
                      <th
                        key={`${header}-${labelIndex}`}
                        scope={labelIndex === rowHeaderLabels.length - 1 ? "row" : undefined}
                      >
                        {rowLabels[labelIndex] ?? ""}
                      </th>
                    ))}
                    {row.values.map((cell, cellIndex) => (
                      <td
                        key={`${rowKey}-${cellIndex}`}
                        className={getMetricCellClassName(cell, cellIndex)}
                      >
                        {cell ?? ""}
                      </td>
                    ))}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function isNegativeValue(value) {
  return typeof value === "string" && value.trim().startsWith("(");
}

const CUSTOMER_DAYS_COLUMNS = [
  { label: "Hospital", width: "365px", getValue: row => row?.Hospital ?? row?.Customer },
  { label: "Sales Rep", width: "130px", getValue: row => row?.["Sales Rep"] },
  { label: "First Order Date", width: "95px", type: "date", getValue: row => row?.["First Order Date"] },
  { label: "Last Order Date", width: "95px", type: "date", getValue: row => row?.["Last Order Date"] },
  { label: "Days Since Last Order", width: "100px", type: "integer", format: "days", getValue: row => row?.["Days Since Last Order"] },
  { label: "Average Weeks between Orders", width: "130px", type: "decimal", format: "averageWeeks", getValue: row => row?.["Average Weeks between Orders"] ?? row?.["Average Weeks Between Orders"] },
  { label: "Orders LTD", width: "90px", type: "integer", getValue: row => row?.["Orders LTD"] },
  { label: "Sales LTD", width: "95px", type: "currency", getValue: row => row?.["Sales LTD"] },
  { label: "Units LTD", width: "90px", type: "integer", getValue: row => row?.["Units LTD"] },
  { label: "Current Qtr Units QTD", width: "105px", type: "integer", getValue: row => row?.["Current Qtr Units QTD"] },
  { label: "Prev. Qtr Units", width: "95px", type: "integer", getValue: row => row?.["Prev. Qtr Units"] ?? row?.["Previous Qtr Units"] },
  { label: "Delta to Prev. Qtr", width: "95px", type: "integer", format: "delta", getValue: row => row?.["Delta to Prev. Qtr"] },
];

const CUSTOMER_DAYS_GREEN = "#63be7b";
const CUSTOMER_DAYS_WHITE = "#fcfcff";

function parseCustomerDaysNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  const text = String(value).trim();
  if (!text) return null;

  const isParenthesesNegative = /^\(.*\)$/.test(text);
  const parsed = Number(text.replace(/[^0-9.-]+/g, ""));
  if (!Number.isFinite(parsed)) return null;

  return isParenthesesNegative ? -Math.abs(parsed) : parsed;
}

function formatCustomerDaysInteger(value) {
  const num = parseCustomerDaysNumber(value);
  return num === null ? "" : Math.round(num).toLocaleString("en-US");
}

function formatCustomerDaysDecimal(value) {
  const num = parseCustomerDaysNumber(value);
  return num === null
    ? ""
    : num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
}

function formatCustomerDaysCurrency(value) {
  const num = parseCustomerDaysNumber(value);
  return num === null
    ? ""
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      }).format(num);
}

function formatCustomerDaysDate(value) {
  if (!value) return "";

  if (typeof value === "number" && Number.isFinite(value)) {
    const excelEpochOffset = 25569;
    const date = new Date(Math.round((value - excelEpochOffset) * 24 * 60 * 60 * 1000));
    return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${String(date.getUTCFullYear()).slice(-2)}`;
  }

  const isoMatch = String(value).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (isoMatch) {
    return `${Number(isoMatch[2])}/${Number(isoMatch[3])}/${isoMatch[1].slice(-2)}`;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return `${date.getMonth() + 1}/${date.getDate()}/${String(date.getFullYear()).slice(-2)}`;
}

function formatCustomerDaysCell(value, type, format) {
  if (format === "delta") {
    const num = parseCustomerDaysNumber(value);
    if (num === null) return "";
    return num < 0
      ? `(${Math.round(Math.abs(num)).toLocaleString("en-US")})`
      : Math.round(num).toLocaleString("en-US");
  }

  if (type === "date") return formatCustomerDaysDate(value);
  if (type === "currency") return formatCustomerDaysCurrency(value);
  if (type === "decimal") return formatCustomerDaysDecimal(value);
  if (type === "integer") return formatCustomerDaysInteger(value);

  return value ?? "";
}

function hexToRgb(hex) {
  const clean = hex.replace("#", "");
  return [
    parseInt(clean.slice(0, 2), 16),
    parseInt(clean.slice(2, 4), 16),
    parseInt(clean.slice(4, 6), 16),
  ];
}

function rgbToHex([r, g, b]) {
  return `#${[r, g, b]
    .map(channel => Math.round(channel).toString(16).padStart(2, "0"))
    .join("")}`;
}

function interpolateHexColor(startHex, endHex, ratio) {
  const start = hexToRgb(startHex);
  const end = hexToRgb(endHex);
  const clampedRatio = Math.max(0, Math.min(1, ratio));

  return rgbToHex(start.map((channel, index) =>
    channel + (end[index] - channel) * clampedRatio
  ));
}

function getCustomerDaysColorScaleStyle(value, min, max, startHex, endHex) {
  const num = parseCustomerDaysNumber(value);
  if (num === null || max <= min) return undefined;

  return {
    backgroundColor: interpolateHexColor(startHex, endHex, (num - min) / (max - min)),
  };
}

function CustomerDaysSinceLastOrderTable({ rows = [] }) {
  const averageWeeksValues = rows
    .map(row => CUSTOMER_DAYS_COLUMNS[5].getValue(row))
    .map(parseCustomerDaysNumber)
    .filter(value => value !== null);
  const averageWeeksThreshold = averageWeeksValues.length
    ? averageWeeksValues.reduce((sum, value) => sum + value, 0) / averageWeeksValues.length
    : 0;
  const deltaValues = rows
    .map(row => CUSTOMER_DAYS_COLUMNS[11].getValue(row))
    .map(parseCustomerDaysNumber)
    .filter(value => value !== null);
  const deltaMax = deltaValues.length ? Math.max(0, ...deltaValues) : 0;

  const getCellClassName = (column, value) => {
    const classes = [
      "vantisCustomerDays__cell",
      column.type ? `vantisCustomerDays__cell--${column.type}` : "vantisCustomerDays__cell--text",
    ];
    const num = parseCustomerDaysNumber(value);

    if (column.format === "days") {
      if (num > 90) classes.push("vantisCustomerDays__cell--daysHigh");
      else if (num >= 60 && num <= 90) classes.push("vantisCustomerDays__cell--daysMedium");
    }

    if (column.format === "delta" && num < 0) {
      classes.push("vantisCustomerDays__cell--negative");
    }

    return classes.join(" ");
  };

  const getCellStyle = (column, value) => {
    if (column.format === "averageWeeks") {
      return getCustomerDaysColorScaleStyle(
        value,
        0,
        averageWeeksThreshold,
        CUSTOMER_DAYS_GREEN,
        CUSTOMER_DAYS_WHITE
      );
    }

    if (column.format === "delta") {
      return getCustomerDaysColorScaleStyle(
        value,
        0,
        deltaMax,
        CUSTOMER_DAYS_WHITE,
        CUSTOMER_DAYS_GREEN
      );
    }

    return undefined;
  };

  return (
    <div className="vantisCustomerDays">
      <div className="dash__tableWrap vantisCustomerDays__wrap">
        <table className="vantisCustomerDays__table" aria-label="Customer Days Since Last Order Report">
          <colgroup>
            {CUSTOMER_DAYS_COLUMNS.map(column => (
              <col key={column.label} style={{ width: column.width }} />
            ))}
          </colgroup>
          <thead>
            <tr className="vantisCustomerDays__titleRow">
              <th colSpan={CUSTOMER_DAYS_COLUMNS.length}>Customer Days Since Last Order Report</th>
            </tr>
            <tr className="vantisCustomerDays__headerRow">
              {CUSTOMER_DAYS_COLUMNS.map(column => (
                <th key={column.label}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td className="tbl__empty" colSpan={CUSTOMER_DAYS_COLUMNS.length}>No customer rows received</td>
              </tr>
            ) : (
              rows.map((row, rowIndex) => (
                <tr key={`${row?.Customer || row?.Hospital || "customer"}-${rowIndex}`}>
                  {CUSTOMER_DAYS_COLUMNS.map(column => {
                    const value = column.getValue(row);

                    return (
                      <td
                        className={getCellClassName(column, value)}
                        key={column.label}
                        style={getCellStyle(column, value)}
                      >
                        {formatCustomerDaysCell(value, column.type, column.format)}
                      </td>
                    );
                  })}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const MONTH_NAME_TO_INDEX = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};
const MONTH_ABBREVIATIONS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function firstPenetrationNumber(value) {
  if (Array.isArray(value)) {
    for (const item of value) {
      const parsed = firstPenetrationNumber(item);
      if (parsed !== null) return parsed;
    }

    return null;
  }

  return parseCustomerDaysNumber(value);
}

function parsePenetrationMonth(value) {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getFullYear(), value.getMonth(), 1);
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    const excelEpochOffset = 25569;
    const date = new Date(Math.round((value - excelEpochOffset) * 24 * 60 * 60 * 1000));
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), 1);
  }

  const text = String(value).trim();
  const monthYearMatch = text.match(/^([A-Za-z]+)\s+(\d{4})$/);
  if (monthYearMatch) {
    const monthIndex = MONTH_NAME_TO_INDEX[monthYearMatch[1].toLowerCase()];
    if (monthIndex !== undefined) return new Date(Number(monthYearMatch[2]), monthIndex, 1);
  }

  const isoMatch = text.match(/^(\d{4})-(\d{1,2})(?:-(\d{1,2}))?/);
  if (isoMatch) return new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, 1);

  const date = new Date(text);
  return Number.isNaN(date.getTime()) ? null : new Date(date.getFullYear(), date.getMonth(), 1);
}

function parsePenetrationDate(value) {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

  const isoMatch = String(value).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (isoMatch) {
    return new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3]));
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function monthKey(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

function formatPenetrationMonthHeader(date) {
  if (!date) return "";
  return `${MONTH_ABBREVIATIONS[date.getMonth()]}-${String(date.getFullYear()).slice(-2)}`;
}

function getQuarter(date) {
  return Math.floor(date.getMonth() / 3) + 1;
}

function getPreviousQuarterDate(date) {
  const currentQuarterStartMonth = Math.floor(date.getMonth() / 3) * 3;
  return new Date(date.getFullYear(), currentQuarterStartMonth - 1, 1);
}

function formatQuarterLabel(date) {
  return date ? `${date.getFullYear()}-Q${getQuarter(date)}` : "";
}

function getPenetrationMonths(rows, latestDate) {
  const firstMonthList = rows.find(row => Array.isArray(row?.["Units Last 15 Months"]))?.["Units Last 15 Months"] || [];
  const parsedMonths = firstMonthList
    .map(item => parsePenetrationMonth(item?.Month))
    .filter(Boolean)
    .sort((a, b) => a - b);

  if (parsedMonths.length > 0) return parsedMonths;

  const latest = parsePenetrationDate(latestDate);
  if (!latest) return [];

  return Array.from({ length: 15 }, (unused, index) =>
    new Date(latest.getFullYear(), latest.getMonth() - (14 - index), 1)
  );
}

function getPenetrationMonthUnits(row, monthDate) {
  const monthRows = Array.isArray(row?.["Units Last 15 Months"]) ? row["Units Last 15 Months"] : [];
  const targetKey = monthKey(monthDate);
  const match = monthRows.find(item => {
    const itemMonth = parsePenetrationMonth(item?.Month);
    return itemMonth && monthKey(itemMonth) === targetKey;
  });

  return firstPenetrationNumber(match?.Units) ?? 0;
}

function formatPenetrationInteger(value, { blankZero = false } = {}) {
  const num = firstPenetrationNumber(value);
  if (num === null || (blankZero && num === 0)) return "";
  return Math.round(num).toLocaleString("en-US");
}

function formatPenetrationDecimal(value, digits = 1) {
  const num = firstPenetrationNumber(value);
  return num === null
    ? ""
    : num.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      });
}

function formatPenetrationPercent(value) {
  if (value === null || value === undefined || value === "") return "";

  // Mixed-type percent columns can contain text like "Too New".
  if (typeof value === "string" && !/[0-9]/.test(value)) return value;

  const num = firstPenetrationNumber(value);

  return num === null
    ? value ?? ""
    : new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
}

function PenetrationByHospitalByMonthTable({ rows = [], latestDate, data, salesAccess }) {
  const tableRef = useRef(null);
  const [tableWidth, setTableWidth] = useState(2320);
  const months = getPenetrationMonths(rows, latestDate);
  const accountNameWidth = useMemo(() => {
    const longestAccountNameLength = rows.reduce((longest, row) => {
      const accountName = row?.["Account Name"] ?? row?.Customer ?? "";
      return Math.max(longest, String(accountName).length);
    }, "Account Name".length);

    return (longestAccountNameLength * 7) + 8;
  }, [rows]);

  useEffect(() => {
    const table = tableRef.current;
    if (!table) return undefined;

    const updateTableWidth = () => {
      const measuredWidth = table.getBoundingClientRect().width;
      if (measuredWidth > 0) setTableWidth(measuredWidth);
    };
    updateTableWidth();

    const resizeObserver = new ResizeObserver(updateTableWidth);
    resizeObserver.observe(table);

    return () => resizeObserver.disconnect();
  }, []);
  const latestDateObject = parsePenetrationDate(latestDate) || months[months.length - 1] || null;
  const previousQuarterDate = latestDateObject ? getPreviousQuarterDate(latestDateObject) : null;
  const currentQuarterLabel = formatQuarterLabel(latestDateObject);
  const previousQuarterLabel = formatQuarterLabel(previousQuarterDate);
  const t3mValues = rows
    .map(row => firstPenetrationNumber(row?.["Units T3M"]))
    .filter(value => value !== null);
  const t3mMax = t3mValues.length ? Math.max(0, ...t3mValues) : 0;

  const DaysSinceLastOrderValuesLabel = data?.customerDaysSinceLastOrderColumnOnly?.title;
  const daysSinceLastOrderByCustomer = new Map(
    (data?.customerDaysSinceLastOrderTableSortedByDaysSinceLastOrder || []).map(row => [
      row?.Customer ?? row?.Hospital,
      row?.["Days Since Last Order"],
    ])
  );

  const columns = [
    { label: "Area", width: "50px", type: "text", getValue: row => row?.Area },
    { label: "Sales Rep", width: "75px", type: "text", getValue: row => row?.["Sales Rep"] },
    { label: "Launch Qtr", width: "50px", type: "text", getValue: row => row?.["Launch Qtr"] },
    {
      label: "Account Name",
      width: `${accountNameWidth}px`,
      isAccountName: true,
      type: "text",
      getValue: row => row?.["Account Name"] ?? row?.Customer,
    },
    ...months.map(month => ({
      label: formatPenetrationMonthHeader(month),
      width: "30px",
      type: "integer",
      format: "monthlyUnits",
      getValue: row => getPenetrationMonthUnits(row, month),
    })),
    {
      label: previousQuarterLabel,
      width: "50px",
      type: "integer",
      getValue: row => row?.["Units Previous Qtr"],
    },
    {
      label: currentQuarterLabel,
      width: "50px",
      type: "integer",
      getValue: row => row?.["Units Current Qtr"],
    },
    {
      label: "Delta",
      width: "50px",
      type: "integer",
      format: "delta",
      getValue: row => row?.Delta,
    },
    {
      label: "Last 15 mo. Total",
      width: "75px",
      type: "integer",
      getValue: row => row?.["Units Last 15 Months Total"],
    },
    ...(salesAccess?.level !== "company" ? [
      {
        label: DaysSinceLastOrderValuesLabel,
        width: "75px",
        type: "integer",
        format: "days",
        getValue: row => daysSinceLastOrderByCustomer.get(row?.Customer ?? row?.["Account Name"]),
      } 
    ] : []),
    // {
    //   label: <>Estimated <br /> CHiP / Qtr</>,
    //   width: "85px",
    //   type: "decimal",
    //   getValue: row => row?.["Estimated CHiP / Qtr"] ?? row?.["Estimated CHiP/Qtr"],
    // },
    // {
    //   label: "Estimated CHiP % Penetration",
    //   width: "100px",
    //   type: "percent",
    //   getValue: row => row?.["Estimated CHiP % Penetration"],
    // },
    // {
    //   label: "Estimated Annual PCIs",
    //   width: "85px",
    //   type: "integer",
    //   format: "manual",
    //   getValue: row => row?.["Estimated Annual PCI's"] ?? row?.["Estimated Annual PCIs"] ?? row?.["Estimated Annual PCI"],
    // },
    // {
    //   label: "Estimated Annual CHiP",
    //   width: "85px",
    //   type: "decimal",
    //   getValue: row => row?.["Estimated Annual CHiP's"] ?? row?.["Estimated Annual CHiP"],
    // },
    // {
    //   label: <>T3M <br /> (last 3 full months)</>,
    //   width: "85px",
    //   type: "integer",
    //   format: "t3m",
    //   getValue: row => row?.["Units T3M"],
    // },
    // {
    //   label: "5% of Procedure Volume",
    //   width: "75px",
    //   type: "decimal",
    //   getValue: row => row?.["5% of Procedure Volume"],
    // },
    {
      label: "Total Procedure Volume",
      width: "75px",
      type: "integer",
      getValue: row => row?.["Total Procedure Volume"],
    },
    {
      label: "Hospital Utilization",
      width: "75px",
      type: "percent",
      getValue: row => row?.["Hospital Utilization"],
    }
  ];
  const otherColumnsWidth = columns.reduce(
    (total, column) => total + (column.isAccountName ? 0 : Number.parseFloat(column.width)),
    0
  );
  const effectiveAccountNameWidth = Math.min(accountNameWidth, tableWidth);
  const availableOtherColumnsWidth = tableWidth - effectiveAccountNameWidth;
  const getColumnWidth = column => {
    const widthInPixels = column.isAccountName
      ? effectiveAccountNameWidth
      : availableOtherColumnsWidth * (Number.parseFloat(column.width) / otherColumnsWidth);

    return `${(widthInPixels / tableWidth) * 100}%`;
  };

  const getCellClassName = (column, value) => {
    const classes = [
      "vantisPenetration__cell",
      column.type ? `vantisPenetration__cell--${column.type}` : "vantisPenetration__cell--text",
    ];
    const num = firstPenetrationNumber(value);

    if (column.format === "days") {
      if (num > 90) classes.push("vantisCustomerDays__cell--daysHigh");
      else if (num >= 60 && num <= 90) classes.push("vantisCustomerDays__cell--daysMedium");
    }

    if (column.format === "manual") classes.push("vantisPenetration__cell--manual");
    if (column.format === "delta" && num < 0) classes.push("vantisPenetration__cell--negative");

    return classes.join(" ");
  };

  const getHeaderClassName = (column) => [
    "vantisPenetration__header",
    column.format === "manual" ? "vantisPenetration__header--manual" : "",
    column.format === "t3m" ? "vantisPenetration__header--t3m" : "",
  ].filter(Boolean).join(" ");

  const getCellStyle = (column, value) => {
    if (column.format !== "t3m") return undefined;

    return getCustomerDaysColorScaleStyle(
      value,
      0,
      t3mMax,
      CUSTOMER_DAYS_WHITE,
      CUSTOMER_DAYS_GREEN
    );
  };

  const formatCell = (column, value) => {
    if (column.format === "monthlyUnits") return formatPenetrationInteger(value, { blankZero: true });
    if (column.type === "percent") return formatPenetrationPercent(value);
    if (column.type === "decimal") return formatPenetrationDecimal(value, 2);
    if (column.type === "integer") return formatPenetrationInteger(value);

    return value ?? "";
  };

  return (
    <div className="vantisPenetration">
      <div className="vantisPenetration__title">Penetration by Hospital by Mo.</div>
      <div className="vantisPenetration__legend">
        {/* <span className="vantisPenetration__legendSwatch" /> */}
        {/* <span>purple = manual client entry</span> */}
      </div>
      <div className="dash__tableWrap vantisPenetration__wrap">
        <table
          ref={tableRef}
          className="vantisPenetration__table"
          aria-label="Penetration by Hospital by Month"
        >
          <colgroup>
            {columns.map((column, index) => (
              <col key={`${column.label}-${index}`} style={{ width: getColumnWidth(column) }} />
            ))}
          </colgroup>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th className={getHeaderClassName(column)} key={`${column.label}-${index}`}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td className="tbl__empty" colSpan={columns.length}>No penetration rows received</td>
              </tr>
            ) : (
              rows.map((row, rowIndex) => (
                <tr key={`${row?.Customer || row?.["Account Name"] || "penetration"}-${rowIndex}`}>
                  {columns.map((column, columnIndex) => {
                    const value = column.getValue(row);

                    return (
                      <td
                        className={getCellClassName(column, value)}
                        key={`${column.label}-${columnIndex}`}
                        style={getCellStyle(column, value)}
                      >
                        {formatCell(column, value)}
                      </td>
                    );
                  })}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function SimpleTable({ columns = [], rows = [], rowLabels = [], rowHeaderLabel = "", ...props }) {
  const hasRowLabels = rowLabels.length > 0;

  return (
    <table className="tbl" {...props}>
      <thead>
        <tr>
          {hasRowLabels && <th>{rowHeaderLabel}</th>}
          {columns.map((c, i) => <th key={i}>{c}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr><td colSpan={columns.length + (hasRowLabels ? 1 : 0)}>No rows</td></tr>
        ) : (
          rows.map((r, i) => (
            <tr key={i}>
              {hasRowLabels && <th scope="row">{rowLabels[i] ?? ""}</th>}
              {r.map((cell, j) => <td key={j}>{cell ?? "—"}</td>)}
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
}


function AspLineChart({ dataPoints = [], height = 240, formatMoney }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    if (!canvasRef.current || dataPoints.length === 0) return;

    const labels = dataPoints.map(p =>
      String(p.quarterLabel ?? "").replace(" Q", "-Q")
    );
    const values = dataPoints.map(p => {
      const num = Number(p.asp);
      return Number.isFinite(num) ? num : null;
    });

    const formatCurrency = (value) => {
      const num = Number(value);
      if (!Number.isFinite(num)) return value;
      return formatMoney ? formatMoney(num) : `$${num.toFixed(2)}`;
    };

    // Chart.js doesn’t draw point labels by default. Here’s a simple plugin to do that.
    const pointLabelPlugin = {
      id: "pointLabel",
      afterDatasetsDraw(chart, args, opts) {
        const { ctx } = chart;
        chart.getDatasetMeta(0).data.forEach((pt, i) => {
          const value = chart.data.datasets[0].data[i];
          if (value == null) return;
          const { x, y } = pt.tooltipPosition();

          ctx.save();
          ctx.fillStyle = opts?.color || "#2b2b2b";
          ctx.font = "12px sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          ctx.fillText(formatCurrency(value), x, y - (opts?.offset ?? 6));
          ctx.restore();
        });
      },
    };

    chartRef.current = new Chart(canvasRef.current, {
      type: "line",
      plugins: [pointLabelPlugin],
      data: {
        labels,
        datasets: [
          {
            label: "ASP",
            data: values,
            borderColor: "#0b5e83",
            backgroundColor: "rgba(11, 94, 131, 0.15)",
            pointBackgroundColor: "#0b5e83",
            pointRadius: 3,
            tension: 0.25,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (context) => `ASP: ${formatCurrency(context.parsed.y)}`,
            },
          },
        },
        scales: {
          y: {
            suggestedMin: 1900,
            suggestedMax: 2300,
            ticks: { 
              stepSize: 100,
              callback: (value) => formatCurrency(value) 
            },
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [dataPoints, formatMoney]);

  if (dataPoints.length === 0) {
    return <ChartPlaceholder height={height} label="No ASP data available" />;
  }

  return (
    <div style={{ height, position: "relative" }}>
      <canvas ref={canvasRef} style={{ width: "100%", height: "100%" }} />
    </div>
  );
}

function DailySalesLineChart({ dataPoints = [], height = 240, formatMoney }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    if (!canvasRef.current || dataPoints.length === 0) return;

    const labels = dataPoints.map(p => p.businessDaysElapsed ?? "");
    const currentCumulative = dataPoints.map(p => {
      const num = Number(p.currentQtrCumulativeSales);
      return Number.isFinite(num) ? num : null;
    });
    const previousCumulative = dataPoints.map(p => {
      const num = Number(p.previousQtrCumulativeSales);
      return Number.isFinite(num) ? num : null;
    });

    const formatCurrency = (value) => {
      const num = Number(value);
      if (!Number.isFinite(num)) return value;
      return formatMoney ? formatMoney(num) : `$${num.toFixed(2)}`;
    };

    const labelEveryXSpaces = {
      id: "labelEveryXSpaces",
      afterDatasetsDraw(chart, args, opts) {
        const { ctx, chartArea } = chart;
        const step = opts?.step ?? 5;
        const padding = opts?.padding ?? 3;
        const bg = opts?.background ?? "rgba(255,255,255,0.9)";
        const border = opts?.border ?? "rgba(0,0,0,0.1)";

        const boxes = [];

        const placeLabel = (x, y, text, color, pointX, pointY, force = false) => {
          const metrics = ctx.measureText(text);
          const w = metrics.width + padding * 2;
          const h = 12 + padding * 2;

          const box = {
            x: x - w / 2,
            y: y - h / 2,
            w,
            h,
          };

          if (force) {
            // clamp box into chart area
            if (box.x < chartArea.left) box.x = chartArea.left;
            if (box.x + box.w > chartArea.right) box.x = chartArea.right - box.w;
            if (box.y < chartArea.top) box.y = chartArea.top;
            if (box.y + box.h > chartArea.bottom) box.y = chartArea.bottom - box.h;

            // re-center text after clamping
            x = box.x + box.w / 2;
            y = box.y + box.h / 2;
          } else {
            if (
              box.x < chartArea.left ||
              box.x + box.w > chartArea.right ||
              box.y < chartArea.top ||
              box.y + box.h > chartArea.bottom
            ) {
              return false;
            }
          }

          // avoid overlaps with other labels
          for (const b of boxes) {
            const overlap =
              box.x < b.x + b.w &&
              box.x + box.w > b.x &&
              box.y < b.y + b.h &&
              box.y + box.h > b.y;
            if (overlap) return false;
          }

          // draw background box
          ctx.save();
          ctx.fillStyle = bg;
          ctx.strokeStyle = border;
          ctx.lineWidth = 1;
          ctx.fillRect(box.x, box.y, box.w, box.h);
          ctx.strokeRect(box.x, box.y, box.w, box.h);

          // pointer (callout)
          const anchorX = Math.min(Math.max(pointX, box.x + 6), box.x + box.w - 6);
          const anchorY = pointY > y ? box.y + box.h : box.y; // bottom or top edge
          const tipY = pointY > y ? anchorY + 6 : anchorY - 6;

          ctx.beginPath();
          ctx.moveTo(anchorX - 6, anchorY);
          ctx.lineTo(anchorX + 6, anchorY);
          ctx.lineTo(anchorX, tipY);
          ctx.closePath();
          ctx.fillStyle = bg;
          ctx.strokeStyle = border;
          ctx.fill();
          ctx.stroke();

          // line from pointer to data point (optional but helps)
          ctx.beginPath();
          ctx.moveTo(anchorX, tipY);
          ctx.lineTo(pointX, pointY);
          ctx.strokeStyle = border;
          ctx.stroke();

          // draw text
          ctx.fillStyle = color;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.font = "12px sans-serif";
          ctx.fillText(text, x, y);
          ctx.restore();

          boxes.push(box);
          return true;
        };

        chart.data.datasets.forEach((ds, datasetIndex) => {
          const meta = chart.getDatasetMeta(datasetIndex);
          meta.data.forEach((pt, i) => {
            const day = Number(chart.data.labels[i]);
            
            const isLast = i === chart.data.labels.length - 1;
            if (
              !isLast && // on the last day
              (!day || day % step !== 0) // on every xth day
            ) return;

            const value = ds.data[i];
            if (value == null) return;

            const label = formatCurrency(value);
            const { x, y } = pt.tooltipPosition();

            // try multiple positions to avoid collisions ( they get tried in order. negative = left/up, positive = right/down )
            const getOffsets = (datasetIndex) =>
            datasetIndex === 0
              ? { xOffsets: [15, -19, 29, -31], yOffsets: [-32, -16, 16, 32] } // for the first dataset (Current Qtr Cumulative Sales) (Assumes Current Qtr is HIGHER than Previous Qtr)
              : { xOffsets: [-15, 19, -29, 31], yOffsets: [32, 16, -16, -32] }; // for the second dataset (Previous Qtr Cumulative Sales) (Assumes Previous Qtr is LOWER than Current Qtr)

            const { xOffsets, yOffsets } = getOffsets(datasetIndex);

            let placed = false
            const force = isLast;
            for (const xo of xOffsets) {
              for (const yo of yOffsets) {
                if (placeLabel(x + xo, y + yo, label, ds.borderColor || "#2b2b2b", x, y, force)) {
                  placed = true;
                  break; // stops inner loop upon placing a label
                };
              }
              if (placed) break; // stops outer loop upon placing a label
            }
          });
        });
      },
    };



    chartRef.current = new Chart(canvasRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: "Current Qtr Cumulative Sales",
            data: currentCumulative,
            borderColor: "#BE5215",
            backgroundColor: "rgba(11, 94, 131, 0.12)",
            pointRadius: 2,
            tension: 0.25,
          },
          {
            label: "Previous Qtr Cumulative Sales",
            data: previousCumulative,
            borderColor: "#002060",
            backgroundColor: "rgba(162, 59, 114, 0.12)",
            pointRadius: 2,
            tension: 0.25,
          },
        ],
      },
      plugins: [labelEveryXSpaces],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          labelEveryXSpaces: { step: 5, offset: 3}, // check afterDatasetsDraw() for default values of options
          legend: { display: true, position: "top" },
          tooltip: {
            callbacks: {
              label: (context) => `${context.dataset.label}: ${formatCurrency(context.parsed.y)}`,
            },
          },
        },
        scales: {
          y: {
            ticks: { callback: (value) => formatCurrency(value) },
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [dataPoints, formatMoney]);

  if (dataPoints.length === 0) {
    return <ChartPlaceholder height={height} label="No daily sales data available" />;
  }

  return (
    <div style={{ height, position: "relative" }}>
      <canvas ref={canvasRef} style={{ width: "100%", height: "100%" }} />
    </div>
  );
}

export function MonthlySalesUnitsChart({ dataPoints = [], height = 240, formatMoney }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    if (!canvasRef.current || dataPoints.length === 0) return;

    const trailing5QuartersLabels = Array.from(new Set(dataPoints.map((p) => p.quarterLabel))).slice(-5); // get unique quarter labels in order of appearance and take the last 5
    const orderedPoints = dataPoints.filter((p) => trailing5QuartersLabels.includes(p.quarterLabel)); // create a copy of the data points array with only the last 5 quarters

    // By Qtr. color coded by month.
    const quarterRows = [];
    orderedPoints.forEach((p) => {  
      const quarter = p.quarterLabel ?? ""; // e.g. "2022 Q1"
      let row = quarterRows.find((r) => r.quarterLabel === quarter); // find existing row for this quarter which may or may not exist

      if (!row) { // if no existing row, create a new one
        row = { quarterLabel: quarter, m1: 0, m2: 0, m3: 0, Total: 0 };
        quarterRows.push(row); // add the new row to the array of quarter rows
      }

      const parts = String(p.monthLabel ?? "").split("-"); // ["2022", "1", "1"]
      const monthNumber = Number(parts[1]); // 2nd index of parts array
      const monthIndexInQuarter = ((monthNumber - 1) % 3) + 1; // calculates month index within the quarter (1, 2, or 3)
      const salesNum = Number(p.sales) || 0; // if sales is not a number, set it to 0

      row[`m${monthIndexInQuarter}`] += salesNum; // adds salesNum to the appropriate month column (m1, m2, or m3) in the row
      row.Total += salesNum; // also keep a running total of sales for the quarter in a separate Total column (not strictly needed for the chart but could be useful for debugging or future features)
    });


    // // By month in Qtr color coded by Qtr.
    // const labels = orderedPoints.map((p) => { 
    //   const parts = String(p.monthLabel ?? "").split("-"); // ["2022", "1", "1"]
    //   const monthNumber = Number(parts[1]); // 2nd index of parts array
    //   if (!Number.isFinite(monthNumber)) return p.monthLabel ?? ""; // return monthLabel if monthNumber is not finite
    //   const monthIndexInQuarter = ((monthNumber - 1) % 3) + 1; // calculates month index within the quarter (1, 2, or 3)
    //   return `M${monthIndexInQuarter}`; // returns "M1", "M2", or "M3"
    // });


    const formatCurrency = (value) => { // function to format currency with commas and 2 decimal places
          const num = Number(value);
          if (!Number.isFinite(num)) return value;
          return formatMoney ? formatMoney(num) : `$${num.toFixed(2)}`;
        };

    const formatUnits = (value) => { // function to format units with commas and no decimal places
      const num = Number(value);
      if (!Number.isFinite(num)) return value;
      return Math.round(num).toLocaleString("en-US");
    };


    const labels = quarterRows.map((q) => [
      String(q.quarterLabel).replace(" Q", "-Q"),
      formatCurrency(q.Total),
    ]);


    const quarterLabels = orderedPoints.map(p => p.quarterLabel ?? "");
    const uniqueQuarters = [];
    quarterLabels.forEach((label) => {
      if (label && !uniqueQuarters.includes(label)) uniqueQuarters.push(label);
    });

    const quarterPalette = [
      "#e07a2c",
      "#1f7a3b",
      "#c62828",
      "#b05ab3",
      "#0e3c91",
    ];
    const quarterColorMap = new Map(
      uniqueQuarters.map((label, index) => [
        label,
        quarterPalette[index % quarterPalette.length],
      ])
    );
    const barColors = quarterLabels.map(
      (label) => quarterColorMap.get(label) || "#6b6b6b"
    );

    const salesValues = orderedPoints.map((p) => {
      const num = Number(p.sales);
      return Number.isFinite(num) ? num : null;
    });
    const unitValues = orderedPoints.map((p) => {
      const num = Number(p.units);
      return Number.isFinite(num) ? num : null;
    });
  
    const valueLabelPlugin = {
      id: "valueLabel",
      afterDatasetsDraw(chart) {
        const { ctx } = chart;
        chart.data.datasets.forEach((dataset, datasetIndex) => {
          if (dataset.type !== "line") return; // skip Sales bars labels

          const meta = chart.getDatasetMeta(datasetIndex);
          meta.data.forEach((point, i) => {
            const value = dataset.data[i];
            if (value == null) return;

            const { x, y } = point.tooltipPosition();
            const isLine = dataset.type === "line";
            const label = isLine ? formatUnits(value) : formatCurrency(value);

            let textY = y - (isLine ? 10 : 6);
            let textBaseline = "bottom";

            if (!isLine) {
              const barTop = typeof point.y === "number" ? point.y : y;
              const barBase = typeof point.base === "number" ? point.base : y;
              textY = (barTop + barBase) / 2;
              textBaseline = "middle";
            }

            ctx.save();
            ctx.fillStyle = isLine ? "#1f1f1f" : "#2b2b2b";
            ctx.font = isLine ? "11px sans-serif" : "10px sans-serif";
            ctx.textAlign = "center";
            ctx.textBaseline = textBaseline;
            ctx.fillText(label, x, textY);
            ctx.restore();
          });
        });
      },
    };

    chartRef.current = new Chart(canvasRef.current, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "M1",
            data: quarterRows.map((q) => q.m1),
            backgroundColor: "#8bd873",
            stack: "sales",
          },
          {
            label: "M2",
            data: quarterRows.map((q) => q.m2),
            backgroundColor: "#d365c7",
            stack: "sales",
          },
          {
            label: "M3",
            data: quarterRows.map((q) => q.m3),
            backgroundColor: "#61c5ec",
            stack: "sales",
          },
        ],

      },
      plugins: [valueLabelPlugin],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        plugins: {
          // title: {
          //   display: true,
          //   text: 'Trailing 4 Qtr. Monthly Sales',
          //   color: '#555',
          //   font: { size: 14, weight: 'normal' },
          // },
          legend: {
            display: true,
            position: "bottom",
            onClick: () => {},
            labels: {
              boxWidth:8,
              boxHeight:12,
            },
          },
          tooltip: {
            callbacks: {
              title: (items) => {
                const index = items?.[0]?.dataIndex ?? 0;
                const row = quarterRows[index];

                if (!row) return "";

                return String(row.quarterLabel).replace(" Q", "-Q");
              },
              label: (context) => {
                const monthLabel = context.dataset.label;
                const value = context.raw ?? context.parsed.y;

                return `${monthLabel}: ${formatCurrency(value)}`;
              },
            },
          },
        },
        scales: {
          x: {
            stacked: true,
            grid: { display: false },
          },
          y: {
            ticks: { callback: (value) => formatCurrency(value) },
            stacked: true,
            beginAtZero: true,
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [dataPoints, formatMoney]);

  if (dataPoints.length === 0) {
    return (
      <ChartPlaceholder height={height} label="No monthly sales data available" />
    );
  }

  return (
    <div style={{ height, position: "relative" }}>
      <canvas ref={canvasRef} style={{ width: "100%", height: "100%" }} />
    </div>
  );
}


function ChartPlaceholder({ height = 240, label }) {
  return (
    <div className="chartPh" style={{ height }}>
      <div className="chartPh__label">{label}</div>
    </div>
  );
}


